import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../../../../services/toast.service';
import { ClienteBasicoResponse } from '../../../../types/ClienteBasicoResponse.type';
import { ClientesService } from './clientes.service';

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrl: './clientes.component.css'
})
export class ClientesComponent implements OnInit{

  clientes!: ClienteBasicoResponse[]

  constructor(private clientService: ClientesService, private router: Router, private toastService: ToastService){}

  ngOnInit(): void {
    this.getClientes()
  }

  getClientes(){
    this.clientService.getBasico().subscribe((data) => {
      this.clientes = data;
    })
  }

  novo(){
    alert('oi')
    this.router.navigate(["novo"])
  }

  desativar(id: string){
    this.clientService.desativar(id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Cliente desativado com sucesso");
        this.getClientes();
      },
      error: (value) => {
        this.toastService.erro("Erro", "Erro ao desativar: " + value)
      }
    })
  }

  ativar(id: string){
    this.clientService.ativar(id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Cliente ativado com sucesso");
        this.getClientes();
      },
      error: (value) => {
        this.toastService.erro("Erro", "Erro ao ativar: " + value)
      }
    })
  }
}
